import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2, ArrowRight } from "lucide-react";
import { BrandLogo } from "../components/BrandLogo";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    const r = await login(email.trim(), password);
    setBusy(false);
    if (r.ok) navigate("/chat");
    else setError(r.error);
  };

  return (
    <div className="min-h-screen flex items-center justify-center hero-bg p-4">
      <div className="w-full max-w-md" data-testid="login-page">
        <div className="bg-[#FFFFFF] backdrop-blur-xl border border-slate-200 rounded-2xl p-8 shadow-[0_20px_80px_rgba(0,102,255,0.15)]">
          <div className="flex flex-col items-center text-center mb-8">
            <BrandLogo size={88} className="mb-4" />
            <h1 className="font-display text-3xl sm:text-4xl font-black tracking-tighter text-slate-900">
              TSU-PARTNERS
            </h1>
            <p className="text-xs uppercase tracking-[0.25em] text-[#4DBFFF] mt-1">
              Die Community für Fahrzeugüberführer
            </p>
            <p className="text-sm text-slate-600 mt-4">
              Willkommen zurück. Melde dich an, um mit deinen Kollegen zu chatten.
            </p>
          </div>

          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2 block">
                E-Mail
              </label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="fahrer@beispiel.de"
                data-testid="login-email-input"
                className="w-full bg-[#F5F8FD] border border-slate-200 rounded-xl px-4 py-3 text-slate-900 placeholder:text-slate-600 focus:outline-none focus:border-[#1D5BFF] focus:ring-2 focus:ring-[#1D5BFF]/30 transition-all"
              />
            </div>
            <div>
              <label className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-2 block">
                Passwort
              </label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                data-testid="login-password-input"
                className="w-full bg-[#F5F8FD] border border-slate-200 rounded-xl px-4 py-3 text-slate-900 placeholder:text-slate-600 focus:outline-none focus:border-[#1D5BFF] focus:ring-2 focus:ring-[#1D5BFF]/30 transition-all"
              />
            </div>

            {error && (
              <div
                className="text-sm text-red-400 bg-red-500/10 border border-red-500/30 rounded-lg px-3 py-2"
                data-testid="login-error"
              >
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={busy}
              data-testid="login-submit-btn"
              className="btn-brand w-full font-bold py-3 rounded-full flex items-center justify-center gap-2"
            >
              {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <>Anmelden <ArrowRight className="w-4 h-4" /></>}
            </button>
          </form>

          <div className="mt-6 text-center text-sm text-slate-600 space-y-2">
            <div>
              <Link to="/passwort-vergessen" data-testid="goto-forgot-link" className="text-[#4DBFFF] hover:text-[#1D5BFF] font-semibold">
                Passwort vergessen?
              </Link>
            </div>
            <div>
              Noch kein Konto?{" "}
              <Link to="/register" data-testid="goto-register-link" className="text-[#4DBFFF] hover:text-[#1D5BFF] font-semibold">
                Jetzt registrieren
              </Link>
            </div>
          </div>
        </div>
        <p className="text-center text-[11px] text-slate-600 mt-6 uppercase tracking-[0.2em]">
          Eine Community von Fahrern · für Fahrer
        </p>
      </div>
    </div>
  );
}
